// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2kQ2b","head":"Table_head__sYhoS","col":"Table_col__24Irj"};